import { render, staticRenderFns } from "./DropdownSearch.vue?vue&type=template&id=84c89cd6"
import script from "./DropdownSearch.vue?vue&type=script&lang=ts"
export * from "./DropdownSearch.vue?vue&type=script&lang=ts"
import style0 from "./DropdownSearch.vue?vue&type=style&index=0&id=84c89cd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports